class AppLog {
  log(message) {
    //console.log(message);
  }
}

let _instance = new AppLog();

export default _instance;